
import $ from 'jquery';

import {getViewControllerName} from './../general/Util.js';

function countImage() {
    const select = document.querySelector('.en_mdl_article_detail__slider_cnt');
    const inner = select.querySelectorAll('.en_mdl_article_detail__thumbs-slider-item');
    const selectImageGrid = document.querySelector('.en_mdl_article_detail__grid_cnt');

    //double negation in order to do type conversion to booleans rather than null values
    if(!selectImageGrid && !!select && inner.length > 0) {
        return inner.length;
    } else if(inner.length === 0) { //account for products with no slider and a single image
        const image = document.querySelector('.simple-slider-slide .en-photoswipe-trigger img');
        if(image.hasAttribute('src')) {
            return 1;
        } else {
            return -1;
        }
    } else {
      //account for grid ADS layout

      const innerGrid = selectImageGrid.querySelectorAll('.en_mdl_article_detail__image');
      if(!!selectImageGrid && innerGrid.length > 0){ //account for grid ADS layout
         return innerGrid.length
      } else {
        return -1;
      }
    }
};

function availableSizes() {
    const select = document.querySelector('#size_select_wrapper');
    if(!!select){
        const inner = select.querySelectorAll('.en_mdl_article_detail__size-choice');

        let emptyCount = 0;
            Array.from(inner).forEach(function(el){
                var stockEmpty = !!el.querySelector(".en_button--disabled");
                    if(stockEmpty){
                        emptyCount+=1
                    }
            })
            let fullDecimal = (((inner.length - emptyCount) / inner.length) * 100)/100
            let finalNum = Number(fullDecimal.toString().substring(0,4)) // Math.round produces unintended errors
            return finalNum //return available product ratio
    } else { //account for products with no size switches
        const select = document.querySelector('.en_button--disabled');
           if(!!select){
               return 0;
           }else{
               return 1;
           }
    }
};

const trackDetailExtAttributes = () => {

    setTimeout( () => {

        const dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            "event": "gtmProductDetailExtAttributes",
            "gtmAvailableSizes": countImage(),
            "gtmAvailableImages": availableSizes()
        });
    }, 1000 );
};

// This is the only jquery here, replace if you want to.
$( document ).ready( function() {

    const v_cl = getViewControllerName();

    switch ( v_cl ) {
        case 'details':

            trackDetailExtAttributes();
            $(document).on( 'finished_change_variant', trackDetailExtAttributes );
        break;
    }
});

export {countImage, availableSizes, trackDetailExtAttributes};